module.exports = __webpack_public_path__ + "static/media/menu.5d71b27a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/containers/Menu/images/menu.jpg
// module id = 587
// module chunks = 0